/**
 * @file reports.ts
 * @module api/apiJSON/reports
 * @description Defines reports API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import {
  IGetSellerReport,
  IAllProductReport,
  IProductVariantReport,
  IInventoryReport,
} from '../../types';
import Method from '../../utils/methods';
export const reportJson = {
  getReportWithKey: (
    { data, fromDate, toDate, utcOffset, warehouse }: IGetSellerReport,
    key: string
  ) => {
    let params: any = {
      utcOffset: utcOffset,
    };
    if (fromDate && toDate) {
      params = {
        ...params,
        fromDate: Method.convertDateToFormat(fromDate, 'YYYY-MM-DD'),
        toDate: Method.convertDateToFormat(toDate, 'YYYY-MM-DD'),
      };
    }
    data.forEach((item: any, index: number) => {
      params[key + '[' + index + ']'] = item;
    });
    if (warehouse) {
      params.warehouse = warehouse;
    }
    return params;
  },
  getAllProductReport: ({ businesses, utcOffset }: IAllProductReport) => {
    let params: any = {
      utcOffset: utcOffset,
    };
    businesses.forEach((item: any, index: number) => {
      params['businesses[' + index + ']'] = item;
    });
    return params;
  },
  getProductVariantReport: ({
    variants,
    utcOffset,
    warehouse,
  }: IProductVariantReport) => {
    let params: any = {
      utcOffset: utcOffset,
    };
    variants.forEach((item: any, index: number) => {
      params['variants[' + index + ']'] = item;
    });
    if (warehouse) {
      params.warehouse = warehouse;
    }
    return params;
  },
  getInventoryReport: ({
    fromDate,
    toDate,
    utcOffset,
    warehouse,
  }: IInventoryReport) => {
    let params: any = {
      utcOffset: utcOffset,
    };
    if (fromDate && toDate) {
      params = {
        ...params,
        fromDate: Method.convertDateToFormat(fromDate, 'YYYY-MM-DD'),
        toDate: Method.convertDateToFormat(toDate, 'YYYY-MM-DD'),
      };
    }
    if (warehouse) {
      params.warehouse = warehouse;
    }
    return params;
  },
};
